import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { LanguageSelector } from './components/LanguageSelector';
import { MatrixRain } from './components/MatrixRain';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <LanguageProvider data-id="element-0">
      <MetaPixel data-id="element-1" />
      <MatrixRain data-id="element-2" />
      <LanguageSelector data-id="element-3" />
      <LandingPage data-id="element-4" />
    </LanguageProvider>;
}